import { UseFloatingReturn, VirtualElement } from "@floating-ui/react";
import { useEffect, useLayoutEffect } from "react";

type UsePositionReferenceParams = {
  refs: UseFloatingReturn["refs"];
  positionReference: VirtualElement | null | undefined;
  getReferenceProps: () => Record<string, unknown>;
};

export const usePositionReference = ({
  refs,
  positionReference,
  getReferenceProps
}: UsePositionReferenceParams) => {
  useLayoutEffect(() => {
    if (positionReference) {
      refs.setPositionReference(positionReference);
    }
  }, [positionReference, refs]);

  const positionedElement = positionReference?.contextElement;
  const describedBy = getReferenceProps()["aria-describedby"];
  useEffect(() => {
    if (!positionedElement || typeof describedBy !== "string") {
      return;
    }

    positionedElement.setAttribute("aria-describedby", describedBy);
    return () => positionedElement.removeAttribute("aria-describedby");
  }, [positionedElement, describedBy]);
};
